import { render, staticRenderFns } from "./cargoFlow.vue?vue&type=template&id=53ec0b58&scoped=true&"
import script from "./cargoFlow.vue?vue&type=script&lang=js&"
export * from "./cargoFlow.vue?vue&type=script&lang=js&"
import style0 from "./cargoFlow.vue?vue&type=style&index=0&id=53ec0b58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ec0b58",
  null
  
)

export default component.exports